var REQUEST_TOKEN;
(function (REQUEST_TOKEN) {
    REQUEST_TOKEN[REQUEST_TOKEN["ANONYMOUS"] = 0] = "ANONYMOUS";
    REQUEST_TOKEN[REQUEST_TOKEN["OPTIONAL"] = 1] = "OPTIONAL";
    REQUEST_TOKEN[REQUEST_TOKEN["SECURE"] = 2] = "SECURE";
})(REQUEST_TOKEN || (REQUEST_TOKEN = {}));
const SECURE_CONFIG_PARAM_VARIANTS = [REQUEST_TOKEN.OPTIONAL, REQUEST_TOKEN.SECURE];
export { REQUEST_TOKEN, SECURE_CONFIG_PARAM_VARIANTS };
//# sourceMappingURL=request.js.map